import useReveal from "../../components/useReveal";
import Seo from "../../components/Seo";
import ArticleGrid from "./ArticleGrid";
import NewsletterForm from "./NewsletterForm";

// Distinct from NewsPage (/research): that page is Ateno's research identity
// (papers, technical reports, hardware research). This is company news —
// announcements and product updates — and lives under Company in the nav,
// not Research. Same underlying article feed, different framing.
export default function NewsroomPage() {
  useReveal();

  const newsroomJsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Ateno Newsroom",
    url: "https://ateno.co/company/newsroom",
    description: "Analysis, announcements and product updates from the Ateno team.",
  };

  return (
    <div className="research-page">
      <Seo
        title="Newsroom"
        description="Analysis, announcements and product updates from the Ateno team."
        path="/company/newsroom"
        type="website"
        jsonLd={newsroomJsonLd}
      />

      <section className="section section-dark research-hero">
        <div className="container" style={{ textAlign: "center" }}>
          <div className="reveal eyebrow">Company</div>
          <h1 className="reveal headline" style={{ marginBottom: 20 }}>Newsroom.</h1>
          <p className="reveal subhead" style={{ maxWidth: 600, margin: "0 auto" }}>
            Analysis, announcements and product updates from the Ateno team.
          </p>
        </div>
      </section>

      <section className="section section-dark research-latest">
        <div className="container">
          <div className="reveal eyebrow research-section-label">Latest updates</div>
          <ArticleGrid basePath="/news" emptyMessage="No updates published yet — check back soon." />
        </div>
      </section>

      <section className="section section-dark research-newsletter-section" style={{ paddingBottom: 80 }}>
        <div className="container">
          <div className="reveal card-dark newsletter-card">
            <div className="newsletter-card-inner">
              <NewsletterForm source="newsroom-page" eyebrow="Newsroom digest" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
